import { useState, useRef, useEffect } from "react";
import { sendAssistantMessage } from "@services/assistant.service";

const QUICK_QUESTIONS = [
  "Puan nasıl kazanılır?",
  "Şans Çarkı ne zaman aktif?",
  "Puanlarım ne kadar süre geçerlidir?",
  "Ustalar puan kazanabilir mi?",
];

function RobotIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="32" fill="#00843D" />
      <rect x="18" y="34" width="28" height="20" rx="6" fill="#00A34C" />
      <rect x="20" y="36" width="24" height="16" rx="4" fill="#A8D5B8" />
      <rect x="22" y="38" width="8" height="8" rx="4" fill="white" />
      <rect x="34" y="38" width="8" height="8" rx="4" fill="white" />
      <circle cx="26" cy="42" r="3" fill="#00421E" />
      <circle cx="38" cy="42" r="3" fill="#00421E" />
      <circle cx="27" cy="41" r="1" fill="white" />
      <circle cx="39" cy="41" r="1" fill="white" />
      <rect x="26" y="48" width="12" height="4" rx="2" fill="#00A34C" />
      <rect x="28" y="49" width="8" height="2" rx="1" fill="#A8D5B8" />
      <rect x="22" y="16" width="20" height="20" rx="6" fill="#00A34C" />
      <rect x="24" y="18" width="16" height="16" rx="4" fill="#A8D5B8" />
      <rect x="30" y="10" width="4" height="8" rx="2" fill="#006B31" />
      <circle cx="32" cy="9" r="3.5" fill="#00A34C" />
      <circle cx="32" cy="9" r="2" fill="#A8D5B8" />
      <rect x="10" y="36" width="8" height="16" rx="4" fill="#00A34C" />
      <rect x="12" y="38" width="4" height="12" rx="2" fill="#A8D5B8" />
      <rect x="46" y="36" width="8" height="16" rx="4" fill="#00A34C" />
      <rect x="48" y="38" width="4" height="12" rx="2" fill="#A8D5B8" />
      <circle cx="27" cy="26" r="1.5" fill="#006B31" />
      <circle cx="32" cy="26" r="1.5" fill="#006B31" />
      <circle cx="37" cy="26" r="1.5" fill="#006B31" />
    </svg>
  );
}

function RobotIconSmall() {
  return (
    <svg width="26" height="26" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="32" fill="#00843D" />
      <rect x="18" y="34" width="28" height="20" rx="6" fill="#00A34C" />
      <rect x="20" y="36" width="24" height="16" rx="4" fill="#A8D5B8" />
      <rect x="22" y="38" width="8" height="8" rx="4" fill="white" />
      <rect x="34" y="38" width="8" height="8" rx="4" fill="white" />
      <circle cx="26" cy="42" r="3" fill="#00421E" />
      <circle cx="38" cy="42" r="3" fill="#00421E" />
      <rect x="22" y="16" width="20" height="20" rx="6" fill="#00A34C" />
      <rect x="24" y="18" width="16" height="16" rx="4" fill="#A8D5B8" />
      <rect x="30" y="10" width="4" height="7" rx="2" fill="#006B31" />
      <circle cx="32" cy="9" r="3" fill="#00A34C" />
    </svg>
  );
}

function TypingDots() {
  return (
    <div style={{ display: "flex", gap: 4, padding: "4px 2px" }}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "#00843D",
            display: "inline-block",
            animation: `cgcdot 1.2s ${i * 0.2}s infinite`,
          }}
        />
      ))}
      <style>{`
        @keyframes cgcdot {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-5px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [showQuick, setShowQuick] = useState(true);
  const [notif, setNotif] = useState(true);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const historyRef = useRef([]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  useEffect(() => {
    if (open) {
      setNotif(false);
      setTimeout(() => inputRef.current?.focus(), 300);
    }
  }, [open]);

  const sendMessage = async (text) => {
    const t = (text || input).trim();
    if (!t || loading) return;
    setInput("");
    setShowQuick(false);
    setMessages((prev) => [...prev, { role: "user", content: t }]);
    historyRef.current = [...historyRef.current, { role: "user", content: t }];
    setLoading(true);
    try {
      // Yapay zeka isteği backend (support-service) üzerinden gider.
      const res = await sendAssistantMessage(historyRef.current);
      const reply = res?.reply || "Bir hata oluştu.";
      setMessages((prev) => [...prev, { role: "assistant", content: reply }]);
      historyRef.current = [...historyRef.current, { role: "assistant", content: reply }];
    } catch {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Bağlantı hatası, lütfen tekrar deneyin." },
      ]);
    }
    setLoading(false);
  };

  const s = {
    wrapper: {
      position: "fixed",
      bottom: 28,
      right: 28,
      zIndex: 9999,
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    },
    fab: {
      width: 64,
      height: 64,
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      background: "transparent",
      padding: 0,
      position: "relative",
      display: "block",
      transition: "transform 0.2s cubic-bezier(.34,1.56,.64,1)",
      boxShadow: "0 4px 18px rgba(0,132,61,0.4)",
    },
    notifDot: {
      position: "absolute",
      top: 0,
      right: 0,
      width: 18,
      height: 18,
      background: "#EF4444",
      borderRadius: "50%",
      border: "2.5px solid white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 10,
      color: "white",
      fontWeight: 600,
    },
    window: {
      position: "absolute",
      bottom: 76,
      right: 0,
      width: 312,
      background: "white",
      borderRadius: "18px 18px 4px 18px",
      boxShadow: "0 8px 36px rgba(0,0,0,0.14)",
      overflow: "hidden",
      transformOrigin: "bottom right",
      transition: "transform 0.26s cubic-bezier(.34,1.56,.64,1), opacity 0.18s",
      transform: open ? "scale(1)" : "scale(0.6)",
      opacity: open ? 1 : 0,
      pointerEvents: open ? "auto" : "none",
    },
    header: {
      background: "linear-gradient(135deg, #00843D 0%, #006B31 100%)",
      padding: "13px 14px",
      display: "flex",
      alignItems: "center",
      gap: 10,
    },
    headerTitle: { color: "white", fontWeight: 700, fontSize: 14, margin: 0, lineHeight: 1.3 },
    headerSub: {
      color: "rgba(255,255,255,0.72)",
      fontSize: 11,
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    onlineDot: { width: 7, height: 7, borderRadius: "50%", background: "#86EFAC", display: "inline-block" },
    closeBtn: {
      marginLeft: "auto",
      background: "rgba(255,255,255,0.15)",
      border: "none",
      borderRadius: "50%",
      width: 28,
      height: 28,
      cursor: "pointer",
      color: "white",
      fontSize: 15,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    body: { padding: "12px 13px 0", display: "flex", flexDirection: "column", gap: 8 },
    greeting: {
      background: "#F0FAF4",
      border: "0.5px solid #6BBF91",
      borderRadius: "4px 13px 13px 13px",
      padding: "9px 11px",
      fontSize: 12.5,
      lineHeight: 1.55,
      color: "#00421E",
      display: "flex",
      gap: 7,
      alignItems: "flex-start",
    },
    quickList: { display: "flex", flexDirection: "column", gap: 5 },
    quickBtn: {
      border: "0.5px solid #6BBF91",
      borderRadius: 20,
      padding: "6px 13px",
      fontSize: 12,
      cursor: "pointer",
      background: "white",
      color: "#00632E",
      textAlign: "left",
      fontFamily: "inherit",
      transition: "background 0.12s",
    },
    messagesArea: {
      maxHeight: 210,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 7,
      padding: "0 13px 4px",
      marginTop: 8,
    },
    msgBot: {
      background: "#F0FAF4",
      border: "0.5px solid #6BBF91",
      borderRadius: "4px 13px 13px 13px",
      padding: "8px 11px",
      fontSize: 12.5,
      lineHeight: 1.55,
      color: "#00421E",
      alignSelf: "flex-start",
      maxWidth: "90%",
    },
    msgUser: {
      background: "#00843D",
      borderRadius: "13px 4px 13px 13px",
      padding: "8px 11px",
      fontSize: 12.5,
      lineHeight: 1.55,
      color: "white",
      alignSelf: "flex-end",
      maxWidth: "90%",
    },
    inputRow: {
      display: "flex",
      gap: 6,
      padding: "8px 13px 12px",
      borderTop: "0.5px solid #D1FAE5",
      marginTop: 8,
      alignItems: "center",
    },
    input: {
      flex: 1,
      border: "0.5px solid #6BBF91",
      borderRadius: 20,
      padding: "7px 12px",
      fontSize: 12,
      background: "#F0FAF4",
      color: "#00421E",
      outline: "none",
      fontFamily: "inherit",
    },
    sendBtn: {
      width: 30,
      height: 30,
      borderRadius: "50%",
      border: "none",
      background: "#00843D",
      color: "white",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      fontSize: 13,
    },
  };

  return (
    <div style={s.wrapper}>
      <div style={s.window}>
        <div style={s.header}>
          <RobotIconSmall />
          <div>
            <p style={s.headerTitle}>Gurme Club Asistanı</p>
            <p style={s.headerSub}>
              <span style={s.onlineDot} /> Çevrimiçi
            </p>
          </div>
          <button style={s.closeBtn} onClick={() => setOpen(false)}>
            ✕
          </button>
        </div>

        <div style={s.body}>
          <div style={s.greeting}>
            <RobotIconSmall />
            <span>Merhaba! Kampanyalar, puan kuralları veya ödüller hakkında yardımcı olabilirim.</span>
          </div>
          {showQuick && (
            <div style={s.quickList}>
              {QUICK_QUESTIONS.map((q) => (
                <button
                  key={q}
                  style={s.quickBtn}
                  onClick={() => sendMessage(q)}
                  onMouseEnter={(e) => (e.target.style.background = "#F0FAF4")}
                  onMouseLeave={(e) => (e.target.style.background = "white")}
                >
                  {q}
                </button>
              ))}
            </div>
          )}
        </div>

        {messages.length > 0 && (
          <div style={s.messagesArea}>
            {messages.map((m, i) => (
              <div key={i} style={m.role === "user" ? s.msgUser : s.msgBot}>
                {m.content}
              </div>
            ))}
            {loading && (
              <div style={s.msgBot}>
                <TypingDots />
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
        )}

        <div style={s.inputRow}>
          <input
            ref={inputRef}
            style={s.input}
            type="text"
            placeholder="Mesajınız..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button style={s.sendBtn} onClick={() => sendMessage()}>
            ➤
          </button>
        </div>
      </div>

      <button
        style={s.fab}
        onClick={() => setOpen((v) => !v)}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {notif && <div style={s.notifDot}>1</div>}
        <RobotIcon size={64} />
      </button>
    </div>
  );
}
